<script setup lang="ts">
import { computed } from 'vue'

import { Loading } from '@element-plus/icons-vue'

interface Props {
  type?: 'primary' | 'danger'
  text: string
  cancelButtonText?: string
  confirmButtonText?: string
  showCancelButton?: boolean
  loading?: boolean
  onConfirm?: () => void
  onCancel?: () => void
}

const { type = 'primary', showCancelButton = true, loading = false } = defineProps<Props>()

const buttonTypeConfig = {
  primary: 'bg-app-brand-blue-500 text-white hover:opacity-90',
  danger: 'bg-app-red-500 text-white'
}

const confirmButtonClass = computed(() => {
  return `confirm-btn ${buttonTypeConfig[type]}`
})
</script>

<template>
  <div class="px-6">
    <p class="mb-7 text-sm leading-5 text-app-black-600">{{ text }}</p>
    <div class="flex items-center justify-end gap-3">
      <button
        v-if="showCancelButton"
        type="button"
        class="confirm-btn border-app-black-100 text-app-black-700"
        :disabled="loading"
        @click="onCancel"
      >
        {{ cancelButtonText || '取消' }}
      </button>
      <button type="button" :class="confirmButtonClass" :disabled="loading" @click="onConfirm">
        <el-icon v-if="loading" class="is-loading mr-1.5"><Loading /></el-icon>
        {{ confirmButtonText || '確定' }}
      </button>
    </div>
  </div>
</template>
<style scoped>
.confirm-btn {
  @apply rounded-4xl border px-6 py-2 text-sm font-medium leading-5;
}
.confirm-btn:disabled {
  @apply cursor-not-allowed opacity-50;
}
</style>
